module.exports = __webpack_public_path__ + "img/twobleed.141bb8f1.png";